<!-- 可自定义页面列表弹窗 -->
<template>
    <div v-loading="loading">
        <div class="table-ctn pageset">
            <el-table
                ref="dialogTable"
                :data="tableData"
                :header-cell-style="{ background: '#F2F6FC' }"
                border=""
                height="500px"
                style="width: 100%; margin-bottom: 5px"
                highlight-current-row
            >
                <el-table-column width="80px" label="序号" type="index" show-overflow-tooltip></el-table-column>
                <el-table-column label="页面" prop="TableName" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="120px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="配置列" size="mini" type="text" @click="showSets(scope.row)">配置列</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="showTBSetsDialog" :append-to-body="true" width="500px">
            <div v-if="showTBSetsDialog">
                <tableStaffSets :staffId="StaffId" :tableCode="tableCode"></tableStaffSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import tableStaffSets from '@/components/common/tableStaffSets';
export default {
    name: '',
    props: ['StaffId', 'StaffName'],
    components: { tableStaffSets },
    data() {
        return {
            title: '',
            tableCode: '',
            tableData: [],
            loading: false,
            showTBSetsDialog: false
        };
    },
    mounted() {
        this.getSetsData();
    },
    methods: {
        getSetsData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpTableConfigList',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) that.tableData = data;
                })
                .catch(() => {})
                .finally(() => {
                    that.loading = false;
                });
        },
        showSets(row) {
            if (row && row.TableCode) {
                this.title = '为【' + this.StaffName + '】配置页面【' + row.TableName + '】列展示';
                this.tableCode = row.TableCode;
                this.showTBSetsDialog = true;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.pageset {
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>
